import forEach from 'lodash/forEach';
import isArray from 'lodash/isArray';
import isObject from 'lodash/isObject';
import map from 'lodash/map';
import camelCase from 'lodash/camelCase';
import snakeCase from 'lodash/snakeCase';

let transformFn;

export function getVal(val) {
  if (isObject(val)) return humps(val); // eslint-disable-line no-use-before-define
  return val;
}

// keyMap and valueMap at the same time.
export function humpsObj(obj) {
  const result = {};

  forEach(obj, (val, key) => {
    result[transformFn(key)] = getVal(val);
  });
  return result;
}

const humps = node => {
  if (isArray(node)) return map(node, humps);
  if (isObject(node)) return humpsObj(node);
  return node;
};

export default (node, mode) => {
  transformFn = {
    camelCase,
    snakeCase,
  }[mode];
  return humps(node);
};
